<template>
  <form @submit.prevent="editUser">
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-envelope font-11"></i>
        <span>Epost</span>
        <em>*</em>
        <input type="email" placeholder="E-post" v-model="user.email" disabled/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Navn</span>
        <em>*</em>
        <input type="text" placeholder="Navn" v-model="user.name"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Etternavn</span>
        <em>*</em>
        <input type="text" placeholder="Etternavn" v-model="user.surname"/>
    </div>
    <div class="input-style has-icon input-style-1 input-required">
        <i class="input-icon fa fa-user font-11"></i>
        <span>Stilling</span>
        <em>*</em>
        <input type="text" placeholder="Stilling" v-model="user.role"/>
    </div>
    <p class="feedback" v-if="feedback">{{ feedback }}</p>
    <div class="clear"></div>
    <div class="center-allign">
        <ui-button color="primary" :loading="loading" >Endre</ui-button>
    </div>
    
  </form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'

export default {
    name: 'EditUser',
    data(){
        return{
            user: null,
            feedback: null,
            loading: false
        }
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'))
    },
    methods :{
        editUser(){
            let oldEmail = JSON.parse(localStorage.getItem('user')).email
            if(this.user.email != oldEmail){
                this.feedback = 'For å endre e-post kontakt administrator'
            } else if (this.user.name && this.user.surname && this.user.role){
                this.loading = true
                this.feedback = null
                firebase.firestore().collection('users').doc(this.user.uid).update({
                    name: this.user.name,
                    surname: this.user.surname,
                    fullName: this.user.name.concat(' ', this.user.surname),
                    role: this.user.role
                }).then(() => {
                    this.loading = false
                    this.feedback = 'Informasjonen din har blitt endret, du vil nå bli logget ut'
                    setTimeout(() => {
                        this.logout()
                    },3000)
                }).catch(err => {
                    this.loading = false
                    this.feedback = err
                })
            } else {
                this.feedback = 'Du kan ikke la være noen felt blanke'
            }
            
        },
        logout(){
            firebase.auth().signOut().then(() => {
                this.$router.push({ name: 'Login' })
                localStorage.removeItem('user');
            })
        },
    }
}
</script>

<style>
.center-allign .ui-button {
    width: 100%
}
</style>